module.exports = __webpack_public_path__ + "static/media/familia.e90f1077.jpg";